import DependenciesAlertPopover from './DependenciesAlertPopover';
import './DependenciesAlertPopover.css';
export default DependenciesAlertPopover;
